import React from 'react';
import { SplitFactory as SplitSdk } from '@splitsoftware/splitio';
// exported for testing purposes
export const __factories = new Map();
// idempotent operation
export function getSplitFactory(config) {
    if (!__factories.has(config)) {
        // SplitSDK is not an idempotent operation
        const newFactory = SplitSdk(config);
        newFactory.sharedClientInstances = new Set();
        newFactory.config = config;
        __factories.set(config, newFactory);
    }
    return __factories.get(config);
}
// idempotent operation
export function getSplitSharedClient(factory, key, trafficType) {
    // factory.client is an idempotent operation
    const client = factory.client(key, trafficType);
    if (factory.sharedClientInstances) {
        factory.sharedClientInstances.add(client);
    }
    return client;
}
export function destroySplitFactory(factory) {
    // call destroy of shared clients and main one
    const destroyPromises = [];
    factory.sharedClientInstances.forEach((client) => destroyPromises.push(client.destroy()));
    destroyPromises.push(factory.client().destroy());
    // remove references to release allocated memory
    factory.sharedClientInstances.clear();
    __factories.delete(factory.config);
    return Promise.all(destroyPromises);
}
export function getIsReady(client) {
    return client.__context.get(client.__context.constants.READY, true) ? true : false;
}
export function getIsReadyFromCache(client) {
    return client.__context.get(client.__context.constants.READY_FROM_CACHE, true) ? true : false;
}
export function getHasTimedout(client) {
    return client.__context.get(client.__context.constants.HAS_TIMEDOUT, true) ? true : false;
}
export function getIsDestroyed(client) {
    return client.__context.get(client.__context.constants.DESTROYED, true) ? true : false;
}
export function getStatus(client) {
    const isReady = client ? getIsReady(client) : false;
    const hasTimedout = client ? getHasTimedout(client) : false;
    return {
        isReady,
        isReadyFromCache: client ? getIsReadyFromCache(client) : false,
        isTimedout: hasTimedout && !isReady,
        hasTimedout,
        isDestroyed: client ? getIsDestroyed(client) : false,
    };
}
// Other utils
/**
 * Checks if React.useContext is available, and logs given message if not
 *
 * @param message
 * @returns boolean indicating if React.useContext is available
 */
export function checkHooks(message) {
    if (!React.useContext) {
        console.log(message);
        return false;
    }
    else {
        return true;
    }
}



// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio-react/es/utils.js